<template>
  <main class="activate-page" role="main">
    <vue-loading :active.sync="is_loading" :can-cancel="false" :is-full-page="true"></vue-loading>

    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-5 activate-section">
        <ul class="nav nav-tabs active-buttons" id="activationOptionsTabs">
          <li class="nav-item">
            <a class="nav-link active mobile" href="#mobile_activations" data-toggle="tab">
              <button type="button" class="btn btn-black btn-block">Mobile</button>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link lte" href="#fixed_lte_activations" data-toggle="tab">
              <button type="button" class="btn btn-black btn-block">Fixed LTE</button>
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane active" id="mobile_activations">
            <div class="container activate" v-if="!is_customer && !is_new_activation">
              <h1 class="section-title">Activate Sim</h1>
              <p
                class="text-normal"
              >Do you already have a me&amp;you mobile SIM card? Enter your SIM Number below (found on the back of your SIM card) and click ‘Verify’ to get started.</p>
              <div class="activation-inputs">
                <a
                  class="input-title"
                  href="javascript:void(0);"
                  v-on:click="display_sim_iccid_img = !display_sim_iccid_img"
                >Where is my SIM number?</a>
                <div class="text-center mt-4">
                  <img
                    src="assets/images/clipart/iccid.png"
                    class="where-sim-no text-center"
                    v-if="display_sim_iccid_img"
                  />
                </div>
                <div class="form-group" v-bind:class="{ 'has-errors': errors.has('simNumber') }">
                  <the-mask
                    mask="####-####-####-####-###"
                    type="tel"
                    v-validate="'required|digits:19'"
                    name="sim_number"
                    class="form-control"
                    data-vv-as="SIM Number"
                    v-model="sim_number"
                    placeholder="Enter your sim number"
                  />
                  <span
                    class="error-message"
                    v-if="errors.has('sim_number')"
                  >A valid 19 digit sim number (ICCID) is required (eg: 8927071234567890123).</span>
                </div>
                <div class="id-number" v-if="show_id_number">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Identification Type?</label>
                        <vue-toggle
                          :options="['ID','PASSPORT']"
                          :default="'ID'"
                          :selected.sync="subscriber.id_type"
                          class="row no-gutters"
                        >
                          <template slot-scope="{item}">
                            <div class="col">
                              <button
                                type="button"
                                v-on:click="subscriber.id_type = item"
                                class="btn btn-default"
                                v-bind:class="['btn btn-block', subscriber.id_type != null && subscriber.id_type === item ? 'btn-primary': 'btn-outline-primary']"
                              >{{ item }}</button>
                            </div>
                          </template>
                        </vue-toggle>
                      </div>
                      <transition name="slide" v-if="id_error">
                        <span class="error-message">Identification type is a required field</span>
                      </transition>
                    </div>

                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>{{subscriber.id_type + ' Number'}}</label>
                        <the-mask
                          type="text"
                          :mask="subscriber.id_type == 'ID' ? '###### #### ###' : 'XXXXXXXXXXXXXXXXXXXXXXXXXX'"
                          v-validate="subscriber.id_type == 'ID' ? 'required|digits:13' : 'required|alpha_num'"
                          name="id_number"
                          class="form-control"
                          v-model="subscriber.id_number"
                          :data-vv-as="subscriber.id_type + ' Number'"
                          :placeholder="subscriber.id_type + ' Number'"
                        />
                        <transition name="slide">
                          <span
                            class="error-message"
                            v-if="errors.has('id_number')"
                          >{{ errors.first('id_number') }}</span>
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="error-message" v-if="error_message != ''">{{ error_message }}</div>
                <button
                  type="button"
                  class="btn-primary btn-block verify"
                  v-on:click="verify"
                >VERIFY</button>
                <div style="text-align:center;">
                  <img
                    class="img-fluid"
                    src="/assets/images/backgrounds/me-you-activation-input-image.png"
                    alt="Acivation-Input-Image"
                  />
                </div>
              </div>
            </div>
            <div class="container welcome-back" v-if="is_customer">
              <h1 class="section-title">Welcome Back</h1>
              <p class="text-normal">Now that you have your SIM, Please log in to activate.</p>
              <div class="activation-inputs">
                <vue-login></vue-login>
              </div>
            </div>
            <div
              class="container activation-options welcome-back"
              v-if="is_new_activation && !is_activated"
            >
              <h1 class="section-title">Select your SIM Option</h1>
              <p class="text-normal"></p>
              <label class="section-label">Sim Options</label>

              <div class="form-group">
                <vue-toggle
                  :options="sim_options"
                  :default="sim_options[0]"
                  :selected.sync="sim_option_type"
                  class="row no-gutters"
                >
                  <template slot-scope="{item}">
                    <div class="col sim-options-btn-holder">
                      <button
                        type="button"
                        class="btn btn-default"
                        v-on:click="sim_option_type = item.value"
                        v-bind:class="['btn btn-block', sim_option_type == item.value ? 'btn-primary': 'btn-outline-primary']"
                      >{{ item.label }}</button>
                    </div>
                  </template>
                </vue-toggle>
              </div>
              <div v-if="sim_option_type == 'prepaid'">
                <div class="subscriber-details">
                  <!-- <span class="details">Your Details</span> -->
                  <div style="position:relative">
                    <span class="details">ENTER YOUR DETAILS FOR RICA</span>
                    <a class="clear-input" @click="clearForm">
                      Clear
                      <i class="fa fa-times"></i>
                    </a>
                  </div>

                  <div class="form-group" v-bind:class="{ 'has-errors': errors.has('first_name') }">
                    <input
                      type="text"
                      v-validate="'required'"
                      name="first_name"
                      class="form-control"
                      v-model="subscriber.first_name"
                      data-vv-as="First Name"
                      placeholder="First Name"
                    />
                    <transition name="slide">
                      <span class="error-message">{{ errors.first('first_name') }}</span>
                    </transition>
                  </div>

                  <div class="form-group" v-bind:class="{ 'has-errors': errors.has('last_name') }">
                    <input
                      type="text"
                      v-validate="'required'"
                      name="last_name"
                      class="form-control"
                      data-vv-as="Last Name"
                      v-model="subscriber.last_name"
                      placeholder="Last Name"
                    />
                    <transition name="slide">
                      <span class="error-message">{{ errors.first('last_name') }}</span>
                    </transition>
                  </div>

                  <div class="id-number">
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label>Identification Type?</label>
                          <vue-toggle
                            :options="['ID','PASSPORT']"
                            :default="'ID'"
                            :selected.sync="subscriber.id_type"
                            class="row no-gutters"
                          >
                            <template slot-scope="{item}">
                              <div class="col">
                                <button
                                  type="button"
                                  v-on:click="subscriber.id_type = item"
                                  class="btn btn-default"
                                  v-bind:class="['btn btn-block', subscriber.id_type != null && subscriber.id_type === item ? 'btn-primary': 'btn-outline-primary']"
                                >{{ item }}</button>
                              </div>
                            </template>
                          </vue-toggle>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="form-group">
                          <label>{{subscriber.id_type + ' Number'}}</label>
                          <the-mask
                            type="text"
                            :mask="subscriber.id_type == 'ID' ? '###### #### ###' : 'XXXXXXXXXXXXXXXXXXXXXXXXXX'"
                            v-validate="subscriber.id_type == 'ID' ? 'required|digits:13' : 'required|alpha_num'"
                            name="id_number"
                            class="form-control"
                            v-model="subscriber.id_number"
                            :data-vv-as="subscriber.id_type + ' Number'"
                            :placeholder="subscriber.id_type + ' Number'"
                          />
                          <transition name="slide">
                            <span
                              class="error-message"
                              v-if="errors.has('id_number')"
                            >{{ errors.first('id_number') }}</span>
                          </transition>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="Document-upload">
                    <label class="section-label">Documents</label>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label>Proof of Address</label>
                          <upload-btn
                            class="btn btn-dark btn-block"
                            :ripple="false"
                            title="Upload"
                            @file-update="address_file"
                          ></upload-btn>
                        </div>
                        <!-- <span
                        class="error-message"
                         v-if="errors.has('')"
                        >{{ errors.first('') }}
                        </span>-->
                      </div>
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label>Copy of {{subscriber.id_type}}</label>
                          <upload-btn
                            class="btn btn-dark btn-block"
                            :ripple="false"
                            title="Upload"
                            @file-update="id_file"
                          ></upload-btn>
                        </div>
                      </div>
                    </div>
                  </div>

                  <vue-address-details
                    :details.sync="address"
                    @updated:address="updateAddress"
                    type="Residential"
                    errorMessage="Street Address is required. Please type your residential street address for RICA."
                  ></vue-address-details>

                  <div class="promo-code">
                    <label class="section-label">Promo Code</label>
                    <div class="form-group">
                      <input
                        type="text"
                        name="promo_code"
                        class="form-control"
                        v-model="promo_code"
                        placeholder="Promo Code"
                      />
                    </div>
                  </div>
                  <div class="error-message" v-if="error_message != ''">{{ error_message }}</div>
                  <div class="page-controls mt-3">
                    <div class="row no-gutters">
                      <button type="button" class="col btn btn-primary next" v-on:click="activate">
                        Activate
                        <i class="fa fa-chevron-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="sim_option_type == 'deal'">
                <div class="col">
                  <router-link
                    class="btn-block btn btn-dark"
                    :to="{ name: 'hot-deals', params: { iccid: sim_number } }"
                    tag="button"
                  >Pick Your Deal</router-link>
                </div>
                <div class="col">
                  <router-link
                    class="btn-block btn btn-dark"
                    :to="{ name: 'build-your-deal', params: { iccid: sim_number } }"
                    tag="button"
                  >Build Your Deal</router-link>
                </div>
              </div>
            </div>
            <div class="container activation-options welcome-back" v-if="is_activated">
              <h1 class="section-title">Congratulations</h1>
              <p class="text-normal">You are now activated.</p>
              <p class="text-normal">Your new me&amp;you number is : +{{ msisdn }}.</p>
            </div>
          </div>
          <div class="tab-pane" id="fixed_lte_activations">
            <div class="container welcome-back">
              <h1 class="section-title">Fixed LTE</h1>
              <p
                class="text-normal"
              >In order to activate your Fixed LTE SIM, please login to the Manage Area.</p>
              <div class="activation-inputs">
                <vue-login></vue-login>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 image-section">
        <img
          class="img-fluid"
          src="/assets/images/backgrounds/me-you-activation-image.jpg"
          alt="Acivation-Input-Image"
        />
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from "vuex";

import AddressModel from "@/models/address.model";
import VueAddressDetails from "@/components/elements/vue-address-details";

import VueLogin from "@/components/elements/vue-login";
import ValidationService from "@/services/validation.service.js";
import SubscriberService from "@/services/subscriber.service.js";
import SubscriberModel from "@/models/subscriber.model";

import UploadButton from "vuetify-upload-button";

export default {
  name: "activate",
  components: {
    "vue-login": VueLogin,
    "upload-btn": UploadButton,
    "vue-address-details": VueAddressDetails
  },
  data: function() {
    return {
      is_loading: false,
      subscriber: new SubscriberModel(),
      address: new AddressModel(),
      files: [],
      is_customer: false,
      is_new_activation: false,
      is_activated: false,
      msisdn: "",
      sim_options: [
        {
          label: "Prepaid",
          value: "prepaid"
        },
        {
          label: "Monthly Deal",
          value: "deal"
        }
      ],
      sim_option_type: "",
      error_message: "",
      sim_number: "8927 07",
      show_id_number: false,
      id_error: "",
      promo_code: "",
      display_sim_iccid_img: false
    };
  },
  computed: {
    ...mapGetters(["cartSims"])
  },
  mounted() {
    var self = this;
    self.sim_number = "8927 07";
  },
  methods: {
    address_file(file) {
      var self = this;
      self.$log.debug("address file : " + file);
      self.files.push({ file: file, type: "address" });
    },
    id_file(file) {
      var self = this;
      self.$log.debug("id file : " + file);
      self.files.push({ file: file, type: "id" });
    },
    updateAddress(address) {
      var self = this;
      self.address = address;
    },
    reset() {
      var self = this;
      self.is_loading = false;
      self.error_message = "";
      self.is_customer = false;
      self.is_new_activation = false;
      self.is_prepaid = true;
      self.display_sim_iccid_img = false;
    },
    verify() {
      var self = this;
      self.reset();
      self.is_loading = true;
      self.$validator.validateAll().then(success => {
        if (!success) return (self.is_loading = success);
        ValidationService.validateIccid(self.sim_number)
          .then(({ data }) => {
            self.is_loading = false;
            self.$log.debug(data);
            self.handleResponse(data);
          })
          .catch(({ response }) => {
            self.is_loading = false;
            self.$log.error(response);
            self.error_message =
              "Unfortunately we cannot complete this request. Please contact support.";
          });
      });
    },
    handleResponse(response) {
      var self = this;
      self.$log.debug("Handle Response", response);
      if (response.success) {
        if (response.data.is_reseller && self.subscriber.id_number != null) {
          self.is_loading = true;
          self.show_id_number = false;
          self.$router.push(
            "/complete-activation?iccid=" +
              self.sim_number +
              "&id=" +
              self.subscriber.id_number
          );
          return;
        } else if (
          response.data.is_reseller &&
          self.subscriber.id_number == null
        ) {
          self.show_id_number = true;
        } else {
          if (self.isSimInCart(self.sim_number)) {
            self.$router.push("checkout");
            return;
          }
          self.is_customer = response.data.assigned > 0;
          self.is_new_activation = !self.is_customer;
        }
      } else {
        self.error_message = response.data.message;
      }
    },
    isSimInCart(simNumber) {
      var self = this;
      var isInCart = false;
      self.cartSims.forEach(element => {
        if (element.iccid == simNumber) isInCart = true;
      });
      return isInCart;
    },
    activate() {
      var self = this;
      self.is_loading = true;
      self.$validator.validateAll().then(success => {
        if (!success) return (self.is_loading = success);
        if (!self.address.is_valid) return false;
        SubscriberService.activate(
          self.sim_number,
          self.subscriber,
          self.address,
          self.files,
          self.promo_code
        )
          .then(response => {
            self.is_loading = false;
            self.$log.debug(response);
            if (response.data.success) {
              self.$scrollTo("body");
              self.is_activated = true;
              self.msisdn = response.data.data.subscriber.msisdn;
            } else {
              self.error_message =
                "Unfortunately we cannot complete this request. Please contact support.";
            }
          })
          .catch(() => {
            self.is_loading = false;
            self.error_message =
              "Unfortunately we cannot complete this request. Please contact support.";
          });
      });
    },
    clearForm() {
      var self = this;
      self.subscriber = new SubscriberModel();
      self.address = new AddressModel();
    }
  }
};
</script>